import { Dispatch } from "react"
import { Action, CheckoutActionKind, State } from "../types/checkoutTypes"
import { Product } from "../product"
import { addBundledProductsToCart } from "./addtoCart"

export const removeFromCart = (
  product: Product,
  products: Product[],
  state: State,
  dispatch: Dispatch<Action>
) => {
  let cartItems = [...state.cartItems] //make a new array so we can keep a clean record of changes
  const cartItemId = product.stripeProduct?.id ?? ""
  const existingItem = cartItems.find(item => item.productId === cartItemId)
  cartItems = cartItems.filter(item => item.productId === cartItemId)

  if (!existingItem) return

  // Update global state
  dispatch({
    type: CheckoutActionKind.REMOVE_FROM_CART,
    payload: { cartItemId },
  })

  if (product.hasSeats()) {
    const seatProductId = product.stripeSeatProduct?.id
    if (seatProductId) {
      dispatch({
        type: CheckoutActionKind.REMOVE_FROM_CART,
        payload: { cartItemId: seatProductId },
      })
    }
  }

  product.productBundles?.forEach(p => {
    const bundle = products.find(pr => pr.id === p.product.id)
    if (p.forced && bundle?.stripeProduct) {
      cartItems = cartItems.filter(
        item => item.productId === bundle!.stripeProduct!.id
      )
      dispatch({
        type: CheckoutActionKind.REMOVE_FROM_CART,
        payload: { cartItemId: bundle.stripeProduct.id },
      })
    }
  })

  state.cartItems.forEach(ci => {
    if (ci.productId !== cartItemId) {
      const product = products.find(pr => pr.stripeProduct?.id === ci.productId)

      //re-run the add bundled products to ensure a clean cart
      if (product) {
        addBundledProductsToCart(product, products, dispatch, cartItems, true) // only add the forced ones
      }
    }
  })
}
